import { Project } from '@constants/router.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const LOGIN_MODULE_STATE: Ng2StateDeclaration = {
  name: `dice.${Project.LOGIN}.**`,
  url: '/login',
  loadChildren: () => import('@login/app/login.module').then((m) => m.LoginModule),
};

export const APP_STATES = [LOGIN_MODULE_STATE];
